export default "__VITE_ASSET__88dae6df__"